import {I18n} from '@aws-amplify/core';
import {SimplePageHeader} from '@flexinet/ui-components';

export const CreatePageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Create Provider Mapping')}
        />
    );
};